import axios from "axios";
import { objToFormData } from "utils/helperFunctions";
import Cookies from "js-cookie";

function objToFormDataConverter(data) {
  let formData;
  if (data instanceof FormData) {
    formData = data;
  } else if (typeof data == "object") {
    formData = objToFormData(data);
  } else if (data == undefined) {
    formData = new FormData();
  } else {
    // formData = data;
  }
  // formData.append("user_token", "UpoKj*12*VLMagUSEGBRGP2sQ*14**14*");
  // formData.append(
  //   "token",
  //   "FUrsI1DeLOYnw*13*ZELu6GDJvve1olnD6gfK4HYc7ZMGx3L*13*8KA*13*Loj*13*F5LOxUWYFl"
  // );
  formData.append("token", Cookies.get("token"));
  return formData;
  // to do: add user token from cookie
}
export function sendRequestHashtags(functionName, data) {
  let formData = objToFormDataConverter(data);
  return axios.post(
    `http://marketgroup.tatdemo.ir/hashtags/${functionName}`,
    formData
  );
}
export function sendRequestAPI3(functionName, data) {
  let formData = objToFormDataConverter(data);
  return axios.post(
    `http://marketgroup.tatdemo.ir/api3/${functionName}`,
    formData
  );
}
export function sendRequestAPI4(functionName, data) {
  let formData = objToFormDataConverter(data);
  return axios.post(
    `http://marketgroup.tatdemo.ir/api4/${functionName}`,
    formData
  );
}
export function sendRequestHashtag(functionName, data) {
  let formData = objToFormDataConverter(data);
  return axios.post(
    `http://marketgroup.tatdemo.ir/hashtags/${functionName}`,
    formData
  );
}
export default function sendRequest(functionName, data) {
  let formData = objToFormDataConverter(data);

  return axios.post(
    `http://marketgroup.tatdemo.ir/api/${functionName}`,
    formData
  );
}
export function sendRequestAPI2(functionName, data) {
  let formData = objToFormDataConverter(data);
  return axios.post(
    `http://marketgroup.tatdemo.ir/api2/${functionName}`,
    formData
  );
}
